
import AccessRight from '@/models/roles/accessRight';
import RoleService from '@/services/roleService';
import { Vue } from 'vue-class-component';
import UpdateRoleModel from '@/models/roles/updateRoleModel';
import { ElLoading, ElMessage } from 'element-plus';
import ErrorCode from '@/constants/ErrorCode';

export default class RoleDetail extends Vue {
  private accountTypes = [
    { value: 0, label: '平台账号' },
    { value: 1, label: '客户账号' },
    { value: 2, label: '平台子账号' },
    { value: 3, label: '客户子账号' },
  ];

  private roleModel: UpdateRoleModel = new UpdateRoleModel();

  private accessRightList: Array<AccessRight> = [];

  private roleId = '';

  private rules = {
    name: [{ required: true, message: '请输入角色名', trigger: 'blur' }],
    accountType: [
      { required: true, message: '请选择账号类型', trigger: 'change' },
    ],
    accessRightCodes: [
      { required: true, message: '请选择权限码', trigger: 'change' },
    ],
  };

  mounted(): void {
    this.roleId = this.$route.params.id as string;
    this.loadAccessRight();
    this.loadData();
  }

  loadAccessRight():void {
    RoleService.getAccessRight().then((response) => {
      if (response.code === ErrorCode.Success) {
        this.accessRightList = response.data;
      }
    });
  }

  loadData(): void {
    RoleService.get(this.roleId)
      .then((result) => {
        if (result.code === ErrorCode.Success) {
          this.roleModel = result.data;
          if (this.roleModel.accessRightCodes === null) {
            this.roleModel.accessRightCodes = [];
          }
          console.info(this.roleModel);
        }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  goBack():void {
    this.$router.back();
  }

  save(): void {
    const updateform: any = this.$refs.form;
    updateform.validate((valid: boolean) => {
      if (valid) {
        const loadingInstance = ElLoading.service({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        RoleService.update(this.roleId, this.roleModel).then(
          (response) => {
            loadingInstance.close();
            if (response.code === ErrorCode.Success) {
              ElMessage.success(response.msg);
            } else {
              ElMessage.error(response.msg);
            }
          },
        );
      }
    });
  }
}
